<template>
  <div class="page-sign-up text-center pt-2 pr-3 pb-3 pl-3">
    <div class="toolbar text-left mb-4">
      <a href="/" class="btn-back" @click.prevent="gotoRoute()">
        <b-icon icon="chevron-left" class="mr-1"/>
        {{ $t("Back") }}</a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <ValidationObserver ref="form" tag="form" class="d-block ml-auto mr-auto" style="width: 500px; max-width: 100%"
                        @submit.prevent="signUp()">
      <b-form-group>
        <ValidationProvider rules="required|email" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.email" :placeholder="$t('Mobile / Email')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mail.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.mobile" :placeholder="$t('Phone number')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mobile.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.name" :placeholder="$t('Fullname')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-user.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }" vid="password">
          <b-input-group class="input-group-trans">
            <b-form-input type="password" v-model="formData.password" :placeholder="$t('Password')"
                          :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-lock.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required|confirmed:password" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input type="password" v-model="formData.confirm" :placeholder="$t('Confirm password')"
                          :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-lock.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-select v-model="formData.idField" class="input-trans credit-card">
            <option v-for="(field, index) in fields" :key="index" :value="field.FieldID">{{$t(field.Name)}}</option>
          </b-select>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-select v-model="formData.country" class="input-trans globel">
            <option v-for="(country, index) in countries" :key="index" :value="country">{{country}}</option>
          </b-select>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group class="mb-4">
        <div>{{$t("What kind of authentication do you want with your users?")}}</div>
        <b-radio-group v-model="formData.idAuthen">
          <b-form-radio value="1">{{$t("Free join")}}</b-form-radio>
          <b-form-radio value="2">{{$t("Free join with account")}}</b-form-radio>
          <b-form-radio value="3">{{$t("Registered join")}}</b-form-radio>
        </b-radio-group>
      </b-form-group>

      <b-form-group class="mb-0">
        <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">{{
            $t("Sign Up")
          }}
        </b-button>
      </b-form-group>
    </ValidationObserver>
    <PanelLoading :show="loading" :message="loadingMessage"/>
  </div>
</template>

<script>
import authenticateService from "../services/authenticate_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "SignUp",
  data: function () {
    return {
      loading: true,
      loadingMessage: "Loading...",
      fields: [],
      countries: [],
      formData: {
        email: "",
        mobile: "",
        name: "",
        password: "",
        confirm: "",
        idField: 1,
        idAuthen: 1,
        country: "Vietnam"
      }
    }
  },
  async created() {
    this.setTitle("Sign Up");
    const response = await authenticateService.getSignInData();
    this.loading = false;
    if (!response) return;

    this.fields = response.Fields;
    this.countries = response.Countries;
  },
  methods: {
    gotoRoute: function (routeName = "Main") {
      if (this.$route.query.routeName)
        routeName = this.$route.query.routeName;

      this.$router.push({name: routeName});
    },
    signUp: async function () {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading == true)
        return;

      this.loadingMessage = "Savings account...";
      this.loading = true;
      const response = await authenticateService.signUp(this.formData);
      this.loading = false;

      if (!response) return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }


      dialogHelper.alert(response.substr(3), "success");
      await this.$router.push({name: "LogIn"});
    }
  }
}
</script>

<style scoped>

</style>